import React, { Component } from 'react'

const ItemCost = ({
  item
}) => {


  const getCostLabel = () => {
    if(item.for_sale) {
      return "Sale Price"
    }
    return "Rental Price"
  }

  const getCostPrice = () => {
    if(item.for_sale) {
      return item.sale_cost
    }
    return item.rental_cost
  }

  if(getCostPrice()){
    return (
      <div className="w-[521px] h-12 justify-start">
        <span class="text-neutral-500 text-[13px] font-normal font-['Roboto'] uppercase leading-5 tracking-wide">{getCostLabel()} </span>
        <span class="text-black text-[16px] font-normal font-['Roboto'] leading-5">{"$"+parseFloat(item.rental_cost).toFixed(2)}<br/></span>
      </div>
    )
  }
}

export default ItemCost